module.exports = __webpack_public_path__ + "img/__arrow__back.1b93eca9.svg";